import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import { Unstable_NumberInput as NumberInput } from '@mui/base';
import * as URL from "../../services/url";
import { toast } from 'react-toastify';
import { getErrorString } from '../../constants/utils';
import PageLoader from '../../components/PageLoader/PageLoader';



export default function Signin() {
  const [countryCode, setCountryCode] = useState("+")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [loading, setLoading] = useState(false);

  const location = useLocation()
  const locName = location.state;
  console.log(locName, "::>>locName")
  const navigate = useNavigate();
  const formData = new FormData();
  formData.append("countrycode", `${countryCode}`)
  formData.append("phonenumber", phoneNumber)

  const handleSubmitPhone = async () => {
    // let reqPayload = {
    //   countrycode: `+${countryCode}`,
    //   phonenumber: phoneNumber,
    // }
    // console.log(reqPayload, "::>> reqPayloady")
    if (!phoneNumber) {
      toast.error("Please enter phone number")
      return;
    }
    else if (!countryCode) {
      toast.error("Please enter country code")
      return;
    }

    setLoading(true)
    try {
      const response = await axios.post(URL.getStriderOtp, formData);
      setLoading(false)
      if (response.status == 200) {
        localStorage.setItem("countryCode", countryCode)
        localStorage.setItem("phoneNumber", phoneNumber)
        navigate("/otp", { state: locName });
        toast.success(response.message)
      }
    } catch (error) {
      toast.error(getErrorString(error))
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleSkipOtp = () => {
    if (!phoneNumber) {
      toast.error("Please enter phone number")
      return;
    }
    else if (!countryCode) {
      toast.error("Please enter country code")
      return;
    }
    else {
      localStorage.setItem("countryCode", countryCode)
      localStorage.setItem("phoneNumber", phoneNumber)
      if (locName == "strider") {
        localStorage.setItem("userRole", "strider")
      } else if (locName == "nonlabs") {
        localStorage.setItem("userRole", "nonlabs")
      }
      navigate("/createprofile", { state: locName });
    }
  }

  const checkCountryCodeInput = (e) => {
    if (e.target.value.length <= 5) {
      setCountryCode(e.target.value)
    } else {
      toast.error("Limit reached")
      return;
    }

  }

  const checkInput = (e) => {
    if (e.target.value.length <= 10) {
      setPhoneNumber(e.target.value)
    } else {
      toast.error("Limit reached")
      return;
    }

  }

  return (
    <React.Fragment>
      {loading && <PageLoader />}
      <CssBaseline />
      <Container maxWidth="lg" className='p-0  fullheight signinpagemain'>
        <div className='signinpage'>
          <div className='signinpageupperpart'>
            <Grid container spacing={2} className='px-20px'>
              {/* <Grid item xs={8}>
        <div className='userpassimg'>
        </div>
       </Grid> */}
              <Grid item xs={12} className='appnameright'>
                <div className='apptitleholder'>
                  <div className='headerapplogo'>
                  </div>
                  <p className='apptitle'>Multi Disease Diagnostic Network Optimization</p>
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <p className='labelname mb-0 text-center'>Access via mobile number</p>
              </Grid>
            </Grid>
            <Grid container spacing={2} className='formrow'>
              <Grid item xs={2} lg={4}>
                {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='+65' /> */}
                <input
                  className='countryCodeInput'
                  onChange={(e) => checkCountryCodeInput(e)}
                  value={countryCode}
                  id="outlined-basic"
                  type='number'
                  placeholder="+"
                />
              </Grid>
              <Grid item xs={10} lg={8}>
                <input
                  className='phoneNumberInput'
                  onChange={(e) => checkInput(e)}
                  value={phoneNumber}
                  id="outlined-basic"
                  type='number'
                  pattern="[0-9]*"
                />
                {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='Phone Number' /> */}
              </Grid>
            </Grid>
            {/* <Grid item xs={12}>
        <p className='labelname mb-0 text-center'>No account yet?</p>
        <p className='labelname mb-0 text-center mt-0 text-underline'>Register</p>
       </Grid> */}
          </div>

          <div className='signinpagelaterpart'>
            <p className='w-100'>
              <button onClick={handleSubmitPhone} className='greenbtn'>Send Access Code</button>

            </p>
          </div>
          <a onClick={handleSkipOtp} className='skipbtn'>Skip OTP</a>
        </div>
      </Container>
    </React.Fragment>
  );
}